import { api } from 'hooks/useApi';

export type ProjectNotePayload = {
  project_id?: number;
  document_id?: string;
  note: string;
};

export type UpdateNotePayload = {
  note: string;
};

export type ProjectNoteResponse = {
  data: {
    created_at: string;
    updated_at: string;
    project?: number;
    document?: string;
    note: string;
  };
  message: string;
};

const createProjectNote = (payload: ProjectNotePayload) => {
  return api.post('/project-notes/', payload);
};

const updateProjectNote = (targetId: number | string, payload: UpdateNotePayload) => {
  return api.patch(`/project-notes/${targetId}/`, payload);
};

const getProjectNote = async (targetId: number | string) => {
  const response = await api.get(`/project-notes/${targetId}/`);

  return response?.data ?? response;
};

const getClientProjectNotes = async (targetId: number | string) => {
  const response = await api.get(`project-notes/${targetId}/all/`);

  return response?.data ?? response;
};

const deleteProjectNote = (targetId: number | string) =>
  api.delete(`/project-notes/${targetId}/`);

type LeadsTableNotesBatchEnvelope = {
  data: Record<string, { note: string; first_name: string; is_mine: boolean }>;
  message: string;
};

const fetchLeadsTableNotesBatch = async (
  entityIds: string[],
): Promise<Record<string, { note: string; first_name: string; is_mine: boolean }>> => {
  if (entityIds.length === 0) {
    return {};
  }
  const response = await api.get<LeadsTableNotesBatchEnvelope>('/project-notes/batch/', {
    params: { project_ids: entityIds.join(',') },
  });

  return response.data?.data ?? {};
};

export default {
  createProjectNote,
  updateProjectNote,
  getProjectNote,
  getClientProjectNotes,
  deleteProjectNote,
  fetchLeadsTableNotesBatch,
};
